<app-navbar-style-three></app-navbar-style-three>
<div class="portfolio-agency-banner pa-bg1 jarallax" data-jarallax='{"speed": 0.3}' style="height: 400px">
    <div class="d-table">
        <div class="d-table-cell">
            <div class="container mt-80">
                <div class="banner-content text-center" style="font-family: 'HindSiliguri';">
                    <h1>কর্মকর্তা ও কর্মচারী</h1>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="works-area ptb-100" style="padding-top: 50px;">
    <div class="container">
        <p style="font-family: 'Mohua'; font-size: 18px;">

            আলহামদুলিল্লাহ, ওয়াসসালাতু ওয়াসসালামু আলা রাসূলিল্লাহ। আম্মা বা'দ- সর্বশ্রেষ্ঠ জাতি
            মুসলিম উম্মাহ। এ জাতি শিক্ষা,
            সংস্কৃতি, অর্থনীতি, রাজনীতির স্বকীয়তা হারিয়েছে অনেক আগেই। ভেঙ্গে চুরমার হয়েছে
            ঈমানী-আখলাকী বুনিয়াদ। বৃটিশোত্তর ভারতীয়
            উপমহাদেশ তার জলন্ত স্বাক্ষী। বহুমুখি সঙ্কটে নিপতিত হয় ইসলামের লালনভূমি বাংলাদেশ। ক্রমেই
            হারাতে থাকে ইসলামী মূল্যবোধ ও
            ঐতিহ্য। হুমকির মুখে পড়ে মুসলিম উম্মাহর নতুন প্রজন্ম। ষাটের দশক। নুয়ে পড়া সে উম্মাহকে
            জাগিয়ে তুলতে ও স্থবির দেহে
            প্রাণ ফিরিয়ে আনতে নতুন করে কদম ফেলে তা‘মীরুল মিল্লাত ট্রাস্ট। ইসলাম ও সাধারণ শিক্ষার
            সমন্বয়ে একটি বাস্তবধর্মী শিক্ষা
            মিশনে তার পথচলা শুরু হয়। অব্যাহত পথচলার ধারাবাহিকতায় ১৯৯৭ সাল থেকে যুক্ত হয় তা‘মীরুল
            মিল্লাত কামিল মাদ্রাসা টঙ্গী। <br>

            যুগোপযোগী দক্ষ আলিমে দ্বীন এবং সমাজের সর্বস্তরের জন্য দেশপ্রেমিক, সৎ ও যোগ্য নাগরিক
            তৈরি। এ মিশনে আত্মনিয়োগ করে বিস্তৃত
            সবুজ ক্যাম্পাস। পাঠদান শুরু হয় প্রাক-প্রাথমিক থেকে কামিল শ্রেণি পর্যন্ত। দাখিল ও আলিম
            শ্রেণিতে সাধারণ ও বিজ্ঞান বিভাগের
            পাশাপাশি কামিলে হাদীস এর সাথে যুক্ত হয় তাফসীর ও ফিক্হ বিভাগ। সফলতার স্বাক্ষর রেখে
            এগিয়ে চলছে তা‘মীরুল মিল্লাত।
            ক্রমান্বয়ে বড় হতে থাকে কুরআনের ছাত্রদের এ আঙিনা। আগ্রহী ও উদ্দিগ্ন অভিভাবকরা অভাব
            অনুভব করেন মেয়েদের দ্বীনী শিক্ষার।
            ২০১২ সাল। অব্যাহত চাহিদার প্রেক্ষিতে প্রতিষ্ঠিত হয় টঙ্গীতে বালিকা শাখা। ক্রমান্বয়ে
            শিশু থেকে কামিল পর্যন্ত পাঠ্যক্রমে
            যুক্ত হয় ছাত্রীরা। শিক্ষার্থীদের মানোন্নয়নে ক্রমান্বয়ে জোরদার হয়েছে ইলমে ক্বিরাআত ও
            আরবী ভাষা শিক্ষা কার্যক্রম।
            সময়োগযোগী আলিমে দ্বীন তৈরির জন্য গ্রহণ করা হয়েছে বিশেষ পদক্ষেপ। নিয়মিত ও সর্বাধিক
            ক্লাস, মাসিক ও সেমিস্টার পরীক্ষার
            মাধ্যমে নিবিড় পরিচর্যা এবং সহ-পাঠ কার্যক্রম ছাত্র-ছাত্রীদের মেধা ও প্রতিভা বিকাশে রাখছে
            কার্যকর ভূমিকা। জাতীয় পর্যায়ে
            শ্রেষ্ঠ শিক্ষা প্রতিষ্ঠান হিসাবে স্বীকৃতি, মাদ্রাসা বোর্ডও করেছে গৌরবান্বিত। <br>

            আলহামদুলিল্লাহ! সূচনা থেকে আজ তা‘মীরুল মিল্লাত টঙ্গী হাজারো ফুলে-ফলে, পত্র-পল্লবে
            প্রস্ফুটিত একটি বৃক্ষ; যা ছড়িয়ে
            পড়েছে পৃথিবীর আনাচে-কানাচে। দেশ-বিদেশে অনুভূত হয় এর সুবাতাস। এর শিক্ষার্থীরা যোগ্য
            দায়ী ইলাল্লাহ হওয়ার লক্ষ্যে ছুটে
            চলছে বিভিন্ন খ্যাতনামা বিশ্ববিদ্যালয়ে, অর্জন করছে দ্বীনের উচ্চতর জ্ঞান। আধুনিক কালের সব
            চ্যালেঞ্জ মোকাবিলায় নিজেদের
            উপস্থিতি জানান দিতে সক্ষম হয়েছে দ্বীনী এ মারকাযের শিক্ষার্থীরা। পেশাগত জীবনে এর
            শিক্ষার্থীদের সফলতা জাতির মাঝে আশার
            সঞ্চার করেছে। দীর্ঘ পথ-পরিক্রমায় প্রতিবন্ধকতার সকল দেয়াল মাড়াতে মহান রবের অফুরন্ত
            রহমত আমাদের একান্ত অবলম্বন।
            শিক্ষকমণ্ডলীর আন্তরিকতা, স্বপ্নবাজ শিক্ষার্থীদের দৃঢ় প্রত্যয় ও পরিশ্রম, অভিভাবকদের
            দু‘আ ও দেশে-বিদেশে সুধীদের ভালোবাসা
            আমাদের চলার পথে পাথেয়। গণপ্রজাতন্ত্রী বাংলাদেশ সরকারের শিক্ষা-প্রশাসনের সকল বিভাগের
            আন্তরিক সহযোগিতা, সর্বোপরি আল্লাহর
            রহমত আমাদের পথচলাকে করেছে মসৃণ ও সুদৃঢ় । <br>

            অভিষ্ট লক্ষ্যের তুলনায় আমাদের মনজিল বহুদুর। অবিরত পথচলায় পরিবর্তনমুখী এ পদক্ষেপ দীর্ঘ
            হবে ইনশাআল্লাহ। প্রত্যাশা করি,
            সুদূরের সে পথ পাড়ি দিতে সত্য ও সুন্দরের প্রত্যাশী সবাই তা‘মীরুল মিল্লাতের সাথে আছেন এবং
            অনাগত দিনগুলোতেও সদয় থাকবেন।
            আল্লাহ তা‘আলা আমাদের সকল সীমাবদ্ধতা মাড়িয়ে সীরাতে মুস্তাকীমের উপর অটল থাকার তাওফীক
            দিন। আমীন!
        </p>
    </div>
</div>